export default __webpack_public_path__ + "static/media/eco-concept-with-group-volunteers (1).a7f10ec8.jpg";